export default "__VITE_ASSET__DpYYOemC__"